import { Workspace } from "../../types/workspace";
import { EntityDto } from "../entity/entity.dto";
import { UserDto } from "../user/user.dto";
import { WorkspaceUserAssignment } from "../../types/workspaceUserAssignment";
import { unpackDateOrNull } from "../dto-helpers";

export class WorkspaceDto {
    static deserialize(dto: WorkspaceDto): Workspace {
        return {
            ...dto,
            primaryAdminUser: dto.primaryAdminUser
                ? UserDto.deserialize(dto.primaryAdminUser)
                : undefined,
            entities: dto.entities?.map(EntityDto.deserialize),
            onboardingCompletedAt: unpackDateOrNull(dto.onboardingCompletedAt),
            isDemo: dto.isDemo,
        };
    }

    id: string;
    name: string;
    primaryAdminUserId: number;
    primaryAdminUser?: UserDto;
    entities?: EntityDto[];
    userAssignments: WorkspaceUserAssignment[];
    isDemo: boolean;
    onboardingCompletedAt: string | null;
    organizationId: string | null;

    constructor(workspace: Workspace) {
        this.id = workspace.id;
        this.name = workspace.name;
        this.primaryAdminUserId = workspace.primaryAdminUserId;
        this.primaryAdminUser = workspace.primaryAdminUser
            ? new UserDto(workspace.primaryAdminUser)
            : undefined;
        this.entities = workspace.entities?.map((e) => new EntityDto(e));
        this.userAssignments = workspace.userAssignments;
        this.isDemo = workspace.isDemo;
        this.onboardingCompletedAt =
            workspace.onboardingCompletedAt?.toISOString() ?? null;
        this.organizationId = workspace.organizationId;
    }
}
